import React, { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";

import "./App.css";
import AppRouter from "./AppRouter";
import ErrorBoundary from "./modules/_components/ErrorBoundary";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { smartech } from "./utils/smartech";

export default function App() {
  const GlobalScript = () => {
    const location = useLocation();

    useEffect(() => {
      smartech("dispatch", "page browse", {
        page_url: window.location.href,
        page_title: document.title,
      })
    }, [location]);

    return null;
  }

  return (
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
          <BrowserRouter>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </BrowserRouter>
        </PersistGate>
      </Provider>
  );
}